import { z } from "zod";

export const postNoteSchema = z.object({
	/**
	 * The note's text, and it is allowed to be empty — a note may be an attachment and nothing
	 * else. What is refused is a note carrying neither, and that is a question no field validator
	 * can answer on its own: the files arrive beside this object. `hasNoteContent` in
	 * `@msuite/utils/notes` is where the two are put together, and the notes handler is what
	 * applies it.
	 *
	 * Nullish rather than optional-with-a-default, because the native editor sends the field as
	 * `undefined` until it is first touched while `notes.note` is `NOT NULL`: the coercion has to
	 * happen before the insert, and here is the one place every caller passes through.
	 */
	note: z
		.string()
		.nullish()
		.transform((note) => note ?? ""),
	noteId: z.string().optional(),
	parentNoteId: z.string().optional(),
	isImportant: z.boolean().optional(),
});

export type PostNoteForm = z.infer<typeof postNoteSchema>;
